import { Grid, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { compose } from 'recompose';
import AddToHomeScreenStyles from './styles';
import BoralLogoUrl from '../../Assets/Logos/Boral-84x69.png';
import { withGlobalStyles } from 'Support/Theme/CreateInjectableStyles/withGlobalStyles';
import hitGTM from 'State/Store/UI/Actions/GTM.action';
import { ADD_TO_HOMESCREEN_ANDROID_DISMISS } from 'State/Store/UI/UI.types';
import * as Bowser from 'bowser';

const AddToHomeScreenAndroidComp = (props) => {
  const { classes } = props;
  const [isOpen, setIsOpen] = useState(false);
  const installPromptEventRef = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      if ('serviceWorker' in navigator) {
        try {
          await navigator.serviceWorker.register('/custom-service-worker.js');
        } catch (ex) {
          console.log(ex);
        }

        window.addEventListener('beforeinstallprompt', (event) => {
          // Prevent Chrome <= 67 from automatically showing the prompt
          event.preventDefault();
          // Stash the event so it can be triggered later.
          installPromptEventRef.current = event;
          // Update the install UI to notify the user app can be installed
          setIsOpen(true);
        });
      }
    })();
  }, []);

  const onDialogClose = () => {
    setIsOpen(false);
    dispatch(hitGTM(ADD_TO_HOMESCREEN_ANDROID_DISMISS));
  };

  const saveToHome = () => {
    setIsOpen(false);
    installPromptEventRef.current.prompt();
    installPromptEventRef.current.userChoice.then((choice) => {
      if (choice.outcome === 'accepted') {
        console.log('accepted');
      } else {
        console.log('failed');
      }
      installPromptEventRef.current = null;
    });
  };

  const browser = Bowser.getParser(window.navigator.userAgent);
  if (browser.getOS().name !== 'Android') {
    return null;
  }

  return (
    <Dialog aria-labelledby="responsive-dialog-title" classes={{ paper: classes.bottomDialog }} fullScreen={false} onClose={onDialogClose} open={isOpen}>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <img src={BoralLogoUrl} alt="Boral logo" height="100" />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" className={classes.fontWeight500}>
              Install Boral Connects
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">Install this app on your home screen for quick and easy access while you&apos;re on the go.</Typography>
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" className={classes.marginBottom2unit} onClick={saveToHome}>
              Add to screen
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

const AddToHomeScreen = compose(withGlobalStyles(AddToHomeScreenStyles))(AddToHomeScreenAndroidComp);

export default AddToHomeScreen;
